(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './curity-ssi-libs-core.js', './kotlinx.coroutines-kotlinx-coroutines-core-js-ir.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./curity-ssi-libs-core.js'), require('./kotlinx.coroutines-kotlinx-coroutines-core-js-ir.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-did'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'curity-ssi-libs-did'.");
    }
    if (typeof this['curity-ssi-libs-core'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-did'. Its dependency 'curity-ssi-libs-core' was not found. Please, check whether 'curity-ssi-libs-core' is loaded prior to 'curity-ssi-libs-did'.");
    }
    if (typeof this['kotlinx.coroutines-kotlinx-coroutines-core-js-ir'] === 'undefined') {
      throw new Error("Error loading module 'curity-ssi-libs-did'. Its dependency 'kotlinx.coroutines-kotlinx-coroutines-core-js-ir' was not found. Please, check whether 'kotlinx.coroutines-kotlinx-coroutines-core-js-ir' is loaded prior to 'curity-ssi-libs-did'.");
    }
    root['curity-ssi-libs-did'] = factory(typeof this['curity-ssi-libs-did'] === 'undefined' ? {} : this['curity-ssi-libs-did'], this['kotlin-kotlin-stdlib'], this['curity-ssi-libs-core'], this['kotlinx.coroutines-kotlinx-coroutines-core-js-ir']);
  }
}(globalThis, function (_, kotlin_kotlin, kotlin_io_curity_ssi_core, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var protoOf = kotlin_kotlin.$_$.kb;
  var initMetadataForCompanion = kotlin_kotlin.$_$.ja;
  var VOID = kotlin_kotlin.$_$.f;
  var getKClassFromExpression = kotlin_kotlin.$_$.d;
  var THROW_CCE = kotlin_kotlin.$_$.te;
  var Unit_instance = kotlin_kotlin.$_$.h5;
  var getStringHashCode = kotlin_kotlin.$_$.ga;
  var ToString = kotlin_io_curity_ssi_core.$_$.m;
  var initMetadataForClass = kotlin_kotlin.$_$.ia;
  var isBlank = kotlin_kotlin.$_$.uc;
  var Regex_init_$Create$ = kotlin_kotlin.$_$.f1;
  var copyToArray = kotlin_kotlin.$_$.o6;
  var StringBuilder = kotlin_kotlin.$_$.hc;
  var CoroutineImpl = kotlin_kotlin.$_$.n9;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.z8;
  var initMetadataForLambda = kotlin_kotlin.$_$.na;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.ka;
  var asFlow = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.p;
  var firstOrNull = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.b;
  var LinkedHashMap_init_$Create$ = kotlin_kotlin.$_$.w;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.n;
  var addAll = kotlin_kotlin.$_$.w5;
  var toSet = kotlin_kotlin.$_$.r8;
  var Exception = kotlin_kotlin.$_$.ke;
  var Exception_init_$Init$ = kotlin_kotlin.$_$.o1;
  var captureStack = kotlin_kotlin.$_$.t9;
  //endregion
  //region block: pre-declaration
  initMetadataForCompanion(Companion);
  initMetadataForClass(Did, 'Did', VOID, VOID, [ToString]);
  initMetadataForCompanion(Companion_0);
  initMetadataForClass(DidUrl, 'DidUrl', VOID, VOID, [ToString]);
  initMetadataForLambda(CompositeDidResolver$resolve$o$collect$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForCoroutine($collectCOROUTINE$1, CoroutineImpl);
  initMetadataForClass(sam$kotlinx_coroutines_flow_FlowCollector$0, 'sam$kotlinx_coroutines_flow_FlowCollector$0', VOID, VOID, VOID, [1]);
  initMetadataForClass(_no_name_provided__qut3iv, VOID, VOID, VOID, VOID, [1]);
  initMetadataForCoroutine($resolveCOROUTINE$0, CoroutineImpl);
  initMetadataForClass(CompositeDidResolver, 'CompositeDidResolver', VOID, VOID, VOID, [1]);
  initMetadataForClass(DidResolutionException, 'DidResolutionException', VOID, Exception);
  //endregion
  function Companion() {
  }
  protoOf(Companion).a1m = function (value) {
    var tmp1_safe_receiver = Companion_getInstance_0().d2i(value);
    var tmp;
    if (tmp1_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.ssi.did.Companion.parse.<anonymous>' call
      var tmp_0;
      if (tmp1_safe_receiver.i2i_1) {
        tmp_0 = tmp1_safe_receiver.e2i_1;
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    return tmp;
  };
  var Companion_instance;
  function Companion_getInstance() {
    return Companion_instance;
  }
  function Did(method, identifier) {
    this.j2i_1 = method;
    this.k2i_1 = identifier;
    this.l2i_1 = 'did:' + this.j2i_1 + ':' + this.k2i_1;
  }
  protoOf(Did).toString = function () {
    return this.l2i_1;
  };
  protoOf(Did).m2i = function (fragment) {
    return new DidUrl(this, VOID, VOID, fragment);
  };
  protoOf(Did).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!(other instanceof Did))
      THROW_CCE();
    return this.l2i_1 === other.l2i_1;
  };
  protoOf(Did).hashCode = function () {
    return getStringHashCode(this.l2i_1);
  };
  function require_0($this, value) {
    var tmp;
    // Inline function 'kotlin.text.isNullOrBlank' call
    // Inline function 'kotlin.contracts.contract' call
    if (value == null || isBlank(value)) {
      tmp = null;
    } else {
      tmp = value;
    }
    return tmp;
  }
  function Companion_0() {
    Companion_instance_0 = this;
    this.v2h_1 = '(?:%[0-9a-fA-F]{2})';
    this.w2h_1 = '(?:[a-zA-Z0-9._-]|(?:%[0-9a-fA-F]{2}))';
    this.x2h_1 = '([a-z0-9]+)';
    this.y2h_1 = '((?:(?:[a-zA-Z0-9._-]|(?:%[0-9a-fA-F]{2}))*:)*((?:[a-zA-Z0-9._-]|(?:%[0-9a-fA-F]{2}))+))';
    this.z2h_1 = '(/[^#?]*)?';
    this.a2i_1 = '([?][^#]*)?';
    this.b2i_1 = '(#.*)?';
    this.c2i_1 = Regex_init_$Create$('^did:([a-z0-9]+):((?:(?:[a-zA-Z0-9._-]|(?:%[0-9a-fA-F]{2}))*:)*((?:[a-zA-Z0-9._-]|(?:%[0-9a-fA-F]{2}))+))(/[^#?]*)?([?][^#]*)?(#.*)?$');
  }
  protoOf(Companion_0).d2i = function (didString) {
    var tmp0_elvis_lhs = this.c2i_1.kc(didString);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var matchResult = tmp;
    // Inline function 'kotlin.collections.toTypedArray' call
    var this_0 = matchResult.zc();
    var groupValues = copyToArray(this_0);
    if (!(groupValues.length === 7)) {
      return null;
    }
    var tmp1_elvis_lhs = require_0(this, groupValues[1]);
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      return null;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var method = tmp_0;
    var tmp2_elvis_lhs = require_0(this, groupValues[2]);
    var tmp_1;
    if (tmp2_elvis_lhs == null) {
      return null;
    } else {
      tmp_1 = tmp2_elvis_lhs;
    }
    var id = tmp_1;
    var tmp2_safe_receiver = groupValues[4];
    var tmp_2;
    if (tmp2_safe_receiver == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.ssi.did.Companion.from.<anonymous>' call
      var tmp_3;
      if (isBlank(tmp2_safe_receiver)) {
        tmp_3 = null;
      } else {
        // Inline function 'kotlin.text.substring' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp_3 = tmp2_safe_receiver.substring(1);
      }
      tmp_2 = tmp_3;
    }
    var path = tmp_2;
    var tmp3_safe_receiver = groupValues[5];
    var tmp_4;
    if (tmp3_safe_receiver == null) {
      tmp_4 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.ssi.did.Companion.from.<anonymous>' call
      var tmp_5;
      if (isBlank(tmp3_safe_receiver)) {
        tmp_5 = null;
      } else {
        // Inline function 'kotlin.text.substring' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp_5 = tmp3_safe_receiver.substring(1);
      }
      tmp_4 = tmp_5;
    }
    var queryString = tmp_4;
    var tmp4_safe_receiver = groupValues[6];
    var tmp_6;
    if (tmp4_safe_receiver == null) {
      tmp_6 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.curity.ssi.did.Companion.from.<anonymous>' call
      var tmp_7;
      if (isBlank(tmp4_safe_receiver)) {
        tmp_7 = null;
      } else {
        // Inline function 'kotlin.text.substring' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp_7 = tmp4_safe_receiver.substring(1);
      }
      tmp_6 = tmp_7;
    }
    var fragment = tmp_6;
    return new DidUrl(new Did(method, id), path, queryString, fragment);
  };
  var Companion_instance_0;
  function Companion_getInstance_0() {
    if (Companion_instance_0 == null)
      new Companion_0();
    return Companion_instance_0;
  }
  function DidUrl(did, path, query, fragment) {
    Companion_getInstance_0();
    path = path === VOID ? null : path;
    query = query === VOID ? null : query;
    fragment = fragment === VOID ? null : fragment;
    this.e2i_1 = did;
    this.f2i_1 = path;
    this.g2i_1 = query;
    this.h2i_1 = fragment;
    this.i2i_1 = (this.f2i_1 == null && this.g2i_1 == null && this.h2i_1 == null);
  }
  protoOf(DidUrl).toString = function () {
    var builder = new StringBuilder(this.e2i_1.toString());
    if (!(this.f2i_1 == null)) {
      builder.e8('/' + this.f2i_1);
    }
    if (!(this.g2i_1 == null)) {
      builder.e8('?' + this.g2i_1);
    }
    if (!(this.h2i_1 == null)) {
      builder.e8('#' + this.h2i_1);
    }
    return builder.toString();
  };
  protoOf(DidUrl).hashCode = function () {
    var result = this.e2i_1.hashCode();
    result = imul(result, 31) + (this.f2i_1 == null ? 0 : getStringHashCode(this.f2i_1)) | 0;
    result = imul(result, 31) + (this.g2i_1 == null ? 0 : getStringHashCode(this.g2i_1)) | 0;
    result = imul(result, 31) + (this.h2i_1 == null ? 0 : getStringHashCode(this.h2i_1)) | 0;
    return result;
  };
  protoOf(DidUrl).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DidUrl))
      return false;
    var tmp0_other_with_cast = other instanceof DidUrl ? other : THROW_CCE();
    if (!this.e2i_1.equals(tmp0_other_with_cast.e2i_1))
      return false;
    if (!(this.f2i_1 == tmp0_other_with_cast.f2i_1))
      return false;
    if (!(this.g2i_1 == tmp0_other_with_cast.g2i_1))
      return false;
    if (!(this.h2i_1 == tmp0_other_with_cast.h2i_1))
      return false;
    return true;
  };
  function CompositeDidResolver$resolve$o$collect$slambda($$this$unsafeFlow, $did, resultContinuation) {
    this.v2i_1 = $$this$unsafeFlow;
    this.w2i_1 = $did;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(CompositeDidResolver$resolve$o$collect$slambda).i2j = function (value, $completion) {
    var tmp = this.j2j(value, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(CompositeDidResolver$resolve$o$collect$slambda).y9 = function (p1, $completion) {
    return this.i2j((p1 == null ? true : !(p1 == null)) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(CompositeDidResolver$resolve$o$collect$slambda).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 8;
            this.v8_1 = 1;
            continue $sm;
          case 1:
            var tmp_0 = this;
            tmp_0.z2i_1 = this.v2i_1;
            var tmp_1 = this;
            tmp_1.a2j_1 = this.x2i_1;
            var tmp_2 = this;
            tmp_2.b2j_1 = this.a2j_1;
            this.w8_1 = 3;
            this.v8_1 = 2;
            suspendResult = this.b2j_1.k2j(this.w2i_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.c2j_1 = suspendResult;
            this.w8_1 = 8;
            this.v8_1 = 4;
            continue $sm;
          case 3:
            this.w8_1 = 8;
            var tmp_3 = this.y8_1;
            if (tmp_3 instanceof DidResolutionException) {
              this.d2j_1 = this.y8_1;
              var tmp_4 = this;
              tmp_4.c2j_1 = null;
              this.v8_1 = 4;
              continue $sm;
            } else {
              throw this.y8_1;
            }

          case 4:
            this.w8_1 = 8;
            this.e2j_1 = this.c2j_1;
            this.f2j_1 = this.e2j_1;
            if (this.f2j_1 == null) {
              this.y2i_1 = Unit_instance;
              this.v8_1 = 7;
              var tmp_5 = this;
              continue $sm;
            } else {
              this.g2j_1 = this.f2j_1;
              this.v8_1 = 5;
              continue $sm;
            }

          case 5:
            this.h2j_1 = this.g2j_1;
            this.v8_1 = 6;
            suspendResult = this.z2i_1.a23(this.h2j_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            this.y2i_1 = suspendResult;
            if (false) {
              this.v8_1 = 1;
              continue $sm;
            }

            this.v8_1 = 7;
            continue $sm;
          case 7:
            return Unit_instance;
          case 8:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 8) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  protoOf(CompositeDidResolver$resolve$o$collect$slambda).j2j = function (value, completion) {
    var i = new CompositeDidResolver$resolve$o$collect$slambda(this.v2i_1, this.w2i_1, completion);
    i.x2i_1 = value;
    return i;
  };
  function CompositeDidResolver$resolve$o$collect$slambda_0($$this$unsafeFlow, $did, resultContinuation) {
    var i = new CompositeDidResolver$resolve$o$collect$slambda($$this$unsafeFlow, $did, resultContinuation);
    var l = function (value, $completion) {
      return i.i2j(value, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function $collectCOROUTINE$1(_this__u8e3s4, collector, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.t2j_1 = _this__u8e3s4;
    this.u2j_1 = collector;
  }
  protoOf($collectCOROUTINE$1).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            var tmp_0 = this;
            tmp_0.v2j_1 = this.u2j_1;
            this.v8_1 = 1;
            var tmp_1 = CompositeDidResolver$resolve$o$collect$slambda_0(this.v2j_1, this.t2j_1.x2j_1, null);
            suspendResult = this.t2j_1.w2j_1.c23(new sam$kotlinx_coroutines_flow_FlowCollector$0(tmp_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            return Unit_instance;
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function sam$kotlinx_coroutines_flow_FlowCollector$0(function_0) {
    this.y2j_1 = function_0;
  }
  protoOf(sam$kotlinx_coroutines_flow_FlowCollector$0).a23 = function (value, $completion) {
    return this.y2j_1(value, $completion);
  };
  function _no_name_provided__qut3iv($this, $did) {
    this.w2j_1 = $this;
    this.x2j_1 = $did;
  }
  protoOf(_no_name_provided__qut3iv).b23 = function (collector, $completion) {
    var tmp = new $collectCOROUTINE$1(this, collector, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(_no_name_provided__qut3iv).c23 = function (collector, $completion) {
    return this.b23(collector, $completion);
  };
  function $resolveCOROUTINE$0(_this__u8e3s4, did, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.h2k_1 = _this__u8e3s4;
    this.i2k_1 = did;
  }
  protoOf($resolveCOROUTINE$0).d9 = function () {
    var suspendResult = this.x8_1;
    $sm: do
      try {
        var tmp = this.v8_1;
        switch (tmp) {
          case 0:
            this.w8_1 = 2;
            var tmp_0 = this;
            var tmp0_elvis_lhs = this.h2k_1.l2k_1.e2(this.i2k_1.j2i_1);
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              throw new DidResolutionException('DID method is not supported');
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }

            tmp_0.j2k_1 = tmp_1;
            this.v8_1 = 1;
            var this_0 = asFlow(this.j2k_1);
            suspendResult = firstOrNull(new _no_name_provided__qut3iv(this_0, this.i2k_1), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var tmp1_elvis_lhs = suspendResult;
            var tmp_2;
            if (tmp1_elvis_lhs == null) {
              throw new DidResolutionException('Could not resolve DID');
            } else {
              tmp_2 = tmp1_elvis_lhs;
            }

            var resolutionResult = tmp_2;
            return resolutionResult;
          case 2:
            throw this.y8_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.w8_1 === 2) {
          throw e;
        } else {
          this.v8_1 = this.w8_1;
          this.y8_1 = e;
        }
      }
     while (true);
  };
  function CompositeDidResolver(didResolvers) {
    this.k2k_1 = didResolvers;
    var tmp = this;
    // Inline function 'kotlin.collections.buildMap' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.collections.buildMapInternal' call
    // Inline function 'kotlin.apply' call
    var this_0 = LinkedHashMap_init_$Create$();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'io.curity.ssi.did.document.CompositeDidResolver.map.<anonymous>' call
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.k2k_1.j();
    while (tmp0_iterator.k()) {
      var element = tmp0_iterator.l();
      // Inline function 'io.curity.ssi.did.document.CompositeDidResolver.map.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator_0 = element.o2k().j();
      while (tmp0_iterator_0.k()) {
        var element_0 = tmp0_iterator_0.l();
        // Inline function 'io.curity.ssi.did.document.CompositeDidResolver.map.<anonymous>.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.getOrPut' call
        var key = element_0.toString();
        var value = this_0.e2(key);
        var tmp_0;
        if (value == null) {
          // Inline function 'io.curity.ssi.did.document.CompositeDidResolver.map.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
          // Inline function 'kotlin.collections.mutableListOf' call
          var answer = ArrayList_init_$Create$();
          this_0.m2(key, answer);
          tmp_0 = answer;
        } else {
          tmp_0 = value;
        }
        tmp_0.e(element);
      }
    }
    tmp.l2k_1 = this_0.r8();
    var tmp_1 = this;
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var this_1 = this.k2k_1;
    var destination = ArrayList_init_$Create$();
    var tmp0_iterator_1 = this_1.j();
    while (tmp0_iterator_1.k()) {
      var element_1 = tmp0_iterator_1.l();
      // Inline function 'io.curity.ssi.did.document.CompositeDidResolver.supportedMethods.<anonymous>' call
      var list = element_1.o2k();
      addAll(destination, list);
    }
    tmp_1.m2k_1 = toSet(destination);
    this.n2k_1 = this.m2k_1;
  }
  protoOf(CompositeDidResolver).k2j = function (did, $completion) {
    var tmp = new $resolveCOROUTINE$0(this, did, $completion);
    tmp.x8_1 = Unit_instance;
    tmp.y8_1 = null;
    return tmp.d9();
  };
  protoOf(CompositeDidResolver).o2k = function () {
    return this.n2k_1;
  };
  function DidResolutionException(message, cause) {
    cause = cause === VOID ? null : cause;
    Exception_init_$Init$(message, cause, this);
    captureStack(this, DidResolutionException);
  }
  //region block: init
  Companion_instance = new Companion();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Companion_instance;
  _.$_$.b = Companion_getInstance_0;
  _.$_$.c = CompositeDidResolver;
  _.$_$.d = DidResolutionException;
  _.$_$.e = DidUrl;
  _.$_$.f = Did;
  //endregion
  return _;
}));

//# sourceMappingURL=curity-ssi-libs-did.js.map
